import React, { useEffect, useState } from "react";
import { HomeWrapper } from "../components/utils/HomeWrapper";
import { useDataProvider } from "../api/DataProvider";
import HelpSnackbar from "../components/utils/HelpSnackbar";
import { useCommProvider } from "../api/CommProvider";
import { DataGrid } from "@material-ui/data-grid";
import { PageTitle } from "../components/utils/PageTitle";
import { RecordDialog } from "../components/dialog/RecordDialog";
import { pDataOrigin, pDataOriginLabel, pDataPermission, pDataPermissionLabel, pRecordsRegisterTab } from "../utils/parameters";
import { Typography } from "@material-ui/core";
import { SignaMedLogo } from '../components/utils/SignaMedLogo';
import { Divider } from "@material-ui/core";
import { formatHistoryDate } from '../api/utils/strings';
import { Grid } from "@material-ui/core";
import { Tabs, Tab } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { makeStyles } from '@mui/styles';

import "../styles/devices/mob_RecordsRegister.css";

const useStyles = makeStyles({
  rowPointer: {
    cursor: 'pointer',
  },
});


export function RecordsRegister() {
  const { t } = useTranslation("global")
  
  /* Dialog */
  const [ openDialog, setOpenDialog ] = useState(false);
  const [ snack, setSnack ] = useState({ open: false, text: "" });
  const { currentUser, token_id } = useDataProvider();
  const { comm_getRecords, comm_removeRecord, comm_revertRemoveRecord, comm_getVideoData } = useCommProvider();
  const [ arr_records, set_arr_records ] = useState([]);
  const [ pageSize, setPageSize ] = useState(10);
  const [ selected_record, setSelectedRecord ] = useState({});
  const [ selected_video, setSelectedVideo ] = useState(null);
  const [ loading, setLoading ] = useState(false);
  const [ split_id, setSplit_id ] = useState(0);
  const [ tabValue, setTabValue ] = useState(pRecordsRegisterTab.videos);
  const [ type, setType ] = useState('VIDEO')

  const [sortModel, setSortModel] = useState([{ field: "timestamp", sort: "desc" }]);

  const [columns, setColumns] = useState([
    // { field: "filename", headerName: t("sRecorder.record_field_record_id"), sortable: false, flex: 0.8   },
    { field: "feedback_lemma", headerName: t("sRecorder.record_field_lemmma"), sortable: false, flex: 0.5 },
    { field: "origin", headerName:  t("sRecorder.record_field_lemmma"), sortable: false, flex: 0.4, renderCell: (params) => gridOriginFormated(params) },
    { field: "timestamp", headerName: t("sRecorder.record_field_date"), sortable: false, flex: 0.5, renderCell: (params) => formatHistoryDate(params.row.timestamp) },
    { field: "available", headerName: t("sRecorder.record_field_state"), sortable: false, flex: 0.4, renderCell: (params) => gridAvailable(params) },
    { field: "permission", headerName: t("sRecorder.record_field_permission"), sortable: false, flex: 0.5, renderCell: (params) => gridPtermissionFormated(params) },
  ]);
  

  function gridOriginFormated(params) {
    switch (params.row.origin) {
      case pDataOrigin.collaboration_LABEL:
        return <span> {pDataOriginLabel.collaboration_LABEL} </span>;
      case pDataOrigin.inference_LABEL:
        return <span> {pDataOriginLabel.inference_LABEL} </span>;
      case pDataOrigin.donate_sign_LABEL:
          return <span> {pDataOriginLabel.donate_sign_LABEL} </span>;
      case pDataOrigin.moveYourSkeleton_LABEL:
            return <span> {pDataOriginLabel.moveYourSkeleton_LABEL} </span>;
      case pDataOrigin.newVariant_LABEL:
        return <span> {pDataOriginLabel.newVariant_LABEL} </span>;
      case pDataOrigin.newSign_LABEL:
        return <span> {pDataOriginLabel.newSign_LABEL} </span>;
      case pDataOrigin.newDefinition_LABEL:
        return <span> {pDataOriginLabel.newDefinition_LABEL} </span>;
      default:
        return <span> {pDataOriginLabel.unknown_LABEL} </span>;
    }
  }


  function gridPtermissionFormated(params) {
    switch (params.row.permission) {
      case pDataPermission.VIDEO:
        return <span> {pDataPermissionLabel.VIDEO} </span>;
      case pDataPermission.KP:
        return <span> {pDataPermissionLabel.KP} </span>;
      case pDataPermission.NONE:
        return <span> {pDataPermissionLabel.NONE} </span>;
    }
  }

  function gridAvailable(params) {
    const issueUser = params.row.available === true ? t("sRecorder.record_available") : t("sRecorder.record_pending_delete");
    return <span>{issueUser}</span>
  }


  useEffect(() => {
    async function getRecords() {
        let result_arr_records = await comm_getRecords(token_id, currentUser, type, split_id, null, null)
        set_arr_records(result_arr_records);
    }
    getRecords();
    return () => { setLoading(false) };
  }, [type]);

  // Actualizar selectedRecord cuando se actualiza arr_records (cambios por borrado o restauración) de este modo se actualizará al igual que la tabla el dialog ya abierto.
  useEffect(() => {

    // console.log("🚀 ~ file: RecordsRegister.js:106 ~ RecordsRegister ~ arr_records:", arr_records)

    const entries = Object.entries(selected_record);  // Comprobar si se habia seleccionado ya un registro previo o no.
    if (entries.length > 0) {
      arr_records.forEach((record) => {
        if (record._id === selected_record._id) {
          setSelectedRecord(record);
        }
      });
    }

    if (arr_records.length > 0) {
      setLoading(true);
    }else{
      setLoading(false);
    }

  }, [arr_records]);
 


  function handlePageSizeChange(params) {
    setPageSize(params.pageSize);
  }

  async function handleRowClick(params, event) {
    setSelectedRecord(params.row);

    let origin = pDataOrigin.unknown_LABEL;
    if (params.row['origin'] === pDataOrigin.collaboration_LABEL){
      origin = pDataOrigin.collaboration_LABEL;
    }else if (params.row['origin'] === pDataOrigin.inference_LABEL){
      origin = pDataOrigin.inference_LABEL;
    }else if (params.row['origin'] === pDataOrigin.donate_sign_LABEL){
      origin = pDataOrigin.donate_sign_LABEL;
    }else if (params.row['origin'] === pDataOrigin.moveYourSkeleton_LABEL){
      origin = pDataOrigin.moveYourSkeleton_LABEL;
    }else if (params.row['origin'] === pDataOrigin.newVariant_LABEL){
      origin = pDataOrigin.newVariant_LABEL;
    }else if (params.row['origin'] === pDataOrigin.newSign_LABEL){
      origin = pDataOrigin.newSign_LABEL;
    }else if (params.row['origin'] === pDataOrigin.newDefinition_LABEL){
      origin = pDataOrigin.newDefinition_LABEL;
    }
    
    setSelectedVideo(await comm_getVideoData(token_id, currentUser, origin, params.row['filename']));
    setOpenDialog(true);
  }

  async function handleRemoveRecord(){
    const record_id_to_delete = selected_record['_id']
    set_arr_records(await comm_removeRecord(token_id, currentUser, type, record_id_to_delete));
  }

  async function handleRevertRemoveRecord(){
    const record_id_to_delete = selected_record['_id']
    set_arr_records(await comm_revertRemoveRecord(token_id, currentUser, type, record_id_to_delete));
  }

  async function handleRemoveRecord(){
    const record_id_to_delete = selected_record['_id']
    await comm_removeRecord(token_id, currentUser, type, record_id_to_delete)
    set_arr_records(await comm_getRecords(token_id, currentUser, type, split_id, null, null));
  }

  async function handleRevertRemoveRecord(){
    const record_id_to_delete = selected_record['_id']
    await comm_revertRemoveRecord(token_id, currentUser, type, record_id_to_delete)
    set_arr_records(await comm_getRecords(token_id, currentUser, type, split_id, null, null));
  }

  async function updateArr_Records(){
    set_arr_records(await comm_getRecords(token_id, currentUser, type, split_id, null, null));
  }

  useEffect(() => {
    // console.log("🚀 ~ file: RecordsRegister.js:176 ~ RecordsRegister ~ tabValue:", tabValue)
    if (tabValue === pRecordsRegisterTab.videos){
      setType('VIDEO')
    }
    if (tabValue === pRecordsRegisterTab.submission){
      setType('SUBMISSION')
    }
  }, [tabValue]);
  


  return (
    <HomeWrapper>
        <PageTitle title= {t("sRecorder.record_title")} />
        <div className="sig_ST_Root">
            <RecordDialog openDialog={openDialog} setOpenDialog={setOpenDialog} selected_record={selected_record} selected_video={selected_video} handleRemoveRecord={handleRemoveRecord} handleRevertRemoveRecord={handleRevertRemoveRecord} updateArr_Records={updateArr_Records} isEvaluationVisible={false} isAdmin={false} type={type}/>
            <HelpSnackbar snack={snack} setSnack={setSnack} />

            <Tabs
                className="sig_SignModal_Tabs"
                value={tabValue}
                onChange={(event, newValue) => {
                  // console.log('CHANGE TAB: ', newValue)
                  setTabValue(newValue);
                }}
                indicatorColor="primary"
                textColor="primary"
                centered
              >
              <Tab className="sig_SignModal_Tab" label={t("sFilter.video")} />
              <Tab className="sig_SignModal_Tab" label={t("sFilter.proposal")} />

            </Tabs>


            <div className="sig_RecordsRegister_ST_Container">
              {loading==true ? (
                <Grid item>
                  <DataGrid
                    autoHeight
                    pageSize={pageSize}
                    onPageSizeChange={handlePageSizeChange}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    disableSelectionOnClick
                    pagination
                    columns={columns}
                    rows={arr_records}
                    sortModel={sortModel}
                    onRowClick={handleRowClick}
                    style={{ cursor: 'pointer' }}
                  />
                </Grid>
              ) : (
                  
                  <div className='sig_RecordsRegister_NoRowsMessage'>
                    <SignaMedLogo size={60} />
                    <Divider className='sig_RecordsRegister_NoRowsMessage_Separator' variant="middle" />
                    <Typography variant='subtitle1'> {t("sRecorder.no_records")} </Typography>
                  </div>
              )}
            </div>


      </div>
    </HomeWrapper>
  );

}